/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortalMessage } from './PortalMessage';
import {
    PortalMessageFromJSON,
    PortalMessageFromJSONTyped,
    PortalMessageToJSON,
    PortalMessageToJSONTyped,
} from './PortalMessage';

/**
 * 
 * @export
 * @interface PortalMessageResponse
 */
export interface PortalMessageResponse {
    /**
     * 
     */
    data: PortalMessage;
}

/**
 * Check if a given object implements the PortalMessageResponse interface.
 */
export function instanceOfPortalMessageResponse(value: object): value is PortalMessageResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function PortalMessageResponseFromJSON(json: any): PortalMessageResponse {
    return PortalMessageResponseFromJSONTyped(json, false);
}

export function PortalMessageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalMessageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PortalMessageFromJSON(json['data']),
    };
}

export function PortalMessageResponseToJSON(json: any): PortalMessageResponse {
    return PortalMessageResponseToJSONTyped(json, false);
}

export function PortalMessageResponseToJSONTyped(value?: PortalMessageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PortalMessageToJSON(value['data']),
    };
}

